import React from 'react';
import { Chart } from 'primereact/chart';
import { DoughnutChartProps } from './DoughnutChart.type';

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  centerText,
  labels,
  backgroundColor,
  styleDoughnutChart,
}) => {
  const data = {
    labels: labels,
    datasets: [
      {
        data: labels,
        backgroundColor,
        borderRadius: 10,
        borderColor: 'transparent',
        spacing: 2,
        weight: 0.6,
      },
    ],
  };

  const options = {
    cutout: '80%',
    radius: '90%',
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
      },
    },
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 800,
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className={`gap-2 w-full relative ${styleDoughnutChart}`}>
      <div className="size-[147.24px] mx-auto">
        <Chart type="doughnut" data={data} options={options} className="size-[147.24px] absolute top-[62px] " />
        <div className="absolute top-[120px] left-1/2 -translate-x-1/2 text-center">
          <p className="m-0 text-[15px] font-semibold">{centerText.title}</p>
          <p className="m-0 text-textColor text-[10.97px] font-normal">
            {centerText.subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DoughnutChart;
